import { defineStore } from 'pinia';
import { setLocalSettings, setSideNavPinnedPreference } from '../utilities/general';

export const useGlobalState = defineStore('globalState', {
    state: () => ({
        loggedInUser: null,
        blocked: false, // UI displays a global loading spinner if true
        menuShowing: false,
        topNavShowing: true,
        UsersTableShowing: false,
        streaming: false,
        videoSrc: '',
        enablePreview: false,
        customLogo: '',
        whitelabel: false,
        customHTML: '',
        userSupport: false,
        displayTerms: true,
        impersonatingName: '',
        displayPromoBanner: false,
        displayKeywordReportNav: false,
        displayGuestbookNav: false,
        snackbar: {
            message: null,
            color: null,
            timeout: null,
            button: {
                text: null,
                color: null,
                callback: () => {},
            },
        },
    }),
    actions: {
        updateDisplayKeywordReportNav(payload) {
            this.displayKeywordReportNav = payload;
        },
        updateDisplayGuestbookNav(payload) {
            this.displayGuestbookNav = payload;
        },
        updateDisplayPromoBanner(payload) {
            this.displayPromoBanner = payload;
        },
        updateDisplayTerms(payload) {
            this.displayTerms = payload;
        },
        updateLoggedInUser(payload) {
            this.loggedInUser = payload;
        },
        updateImpersonatingName(payload) {
            this.impersonatingName = payload;
        },
        updateCustomHTML(payload) {
            this.customHTML = payload;
        },
        updateUserSupport(payload) {
            this.userSupport = payload;
        },
        updateCustomLogo(payload) {
            this.customLogo = payload;
        },
        updateWhitelabel(payload) {
            this.whitelabel = payload;
        },
        toggleSideNav(saveChange) {
            this.menuShowing = !this.menuShowing;
            if (saveChange) {
                setSideNavPinnedPreference(this.menuShowing);
                if (this.menuShowing) {
                    setLocalSettings('appSettings', { menuState: 'max' });
                } else {
                    setLocalSettings('appSettings', { menuState: 'min' });
                }
            }
        },
        toggleTopNav(payload) {
            this.topNavShowing = payload;
        },
        toggleUsersTable() {
            this.UsersTableShowing = !this.UsersTableShowing;
        },
        toggleStreaming(payload) {
            this.streaming = payload;
        },
        setVideoSrc(payload) {
            this.videoSrc = payload;
        },
        setEnablePreview(payload) {
            this.enablePreview = payload;
        },
        showSnackbar({ message = '', color = '', timeout = '2000', button = null }) {
            this.snackbar.message = message;
            this.snackbar.color = color;
            this.snackbar.timeout = timeout;
            const defaultCallback = () => {};
            if (button !== null) {
                this.snackbar.button = {};
                this.snackbar.button.text = button.text || null;
                this.snackbar.button.color = button.color || null;
                this.snackbar.button.callback = button.callback || defaultCallback;
            } else {
                this.snackbar.button = null;
            }
        },
        closeSnackbar() {
            this.snackbar.message = null;
            this.snackbar.color = null;
            this.snackbar.timeout = null;
            this.snackbar.button = null;
        },
        block(payload) {
            this.blocked = payload;
        },
    },
});
